<template>
  <div>
    <table class="export_table" id="export_table">
      <tr>
        <th>No</th>
        <th>가입번호</th>
        <th>본부</th>
        <th>사업구분</th>
        <th>구축구분</th>
        <th>이동전화번호</th>
        <th>개통일</th>
        <th>등록일</th>
        <th>처리현황</th>
        <th>현재상태</th>
      </tr>
      <tr :key="'excel_exp_' + index" v-for="(item, index) in list">
        <td>{{index + 1}}</td>
        <td>{{item.registryNum}}&#8203;</td>
        <td>
          <template v-if="item.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="item.projectType != null">
            <template v-for="prt in prtList" v-if="prt.codeValue === item.projectType">{{prt.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="item.structType != null">
            <template v-for="stt in sttList" v-if="stt.codeValue === item.structType">{{stt.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>{{item.mobileNum}}&#8203;</td>
        <td>{{item.connectedDate}}&#8203;</td>
        <td>{{item.registerDate}}&#8203;</td>
        <td>
          <template v-if="item.progressType != null">
            <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="item.currentState != null">
            <template v-for="crs in crsList" v-if="crs.codeValue === item.currentState">{{crs.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import xlsx from 'xlsx/xlsx'
import common from '../../script/common'

export default {
  props: ['exportData', 'filter'],
  data () {
    return {
      ofcList: [],
      ofc1List: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      list: this.exportData,
      localFilter: this.filter
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            this.$emit('prepared')
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    exportData (newVal) {
      this.list = newVal.list
    }
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    download () {
      let mainData = xlsx.utils.table_to_sheet(document.getElementById('export_table'))
      let workBook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workBook, mainData, 'sheet1')
      let strToday = common.getFormattedDate(Date.now()).replaceAll('-', '')
      xlsx.writeFile(workBook, '모뎀현황_' + strToday + '_' + this.localFilter.page + '.xlsx')
      // console.log('download', new Date())
    }
  }
}
</script>

<style scoped>
.export_table {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/excel/ExcelDownloadModemInfo.vue